// extracted by mini-css-extract-plugin
export default {"cabinet":"CabinetLayout_cabinet__1iBxc","header":"CabinetLayout_header__olCNO","cabinet_admin":"CabinetLayout_cabinet_admin__fxBsN"};